import { useAnnouncementAnchor } from './Announcements';

// Today's two tabs under the calorie card, each with a one-line summary; sticks to the top when scrolling.
export const DAY_TABS = [{ id: 'meals', label: 'Ăn uống' }, { id: 'workout', label: 'Tập luyện' }];

export default function DayTabs({ tab, onChange, summaries, dot }) {
  const workoutAnchor = useAnnouncementAnchor('day_workout_tab');
  return (
    <div className="sticky top-[env(safe-area-inset-top)] z-20 -mx-4 bg-base-200 px-4 py-2">
      <div role="tablist" aria-label="Hôm nay" className="grid grid-cols-2 gap-1 rounded-[16px] bg-base-300/70 p-1">
        {DAY_TABS.map((t) => {
          const active = tab === t.id;
          return (
            <button key={t.id} ref={t.id === 'workout' ? workoutAnchor : undefined} type="button" role="tab" aria-selected={active} onClick={() => onChange(t.id)}
              className={`flex min-h-12 flex-col items-center justify-center rounded-[12px] px-2 ${active ? 'bg-base-100 shadow-sm' : 'text-muted'}`}>
              <span className="flex items-center gap-1.5 text-sm font-bold">
                {t.label}
                {t.id === 'workout' && dot && <span className="size-2 rounded-full bg-[#e8743b]" aria-label="có lịch hẹn mới" />}
              </span>
              <span className="truncate text-[11px] text-muted">{summaries[t.id]}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
